import { render, staticRenderFns } from "./unauthorized-screen.vue?vue&type=template&id=1983f581&"
import script from "./unauthorized-screen.vue?vue&type=script&lang=js&"
export * from "./unauthorized-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports